export const PO_SHIPMENT_STATUS_COLORS = {
  "Pickup Requested": "#F4B400",
  "Pickup Delayed": "#E67E22",
  "Dock Appt Confirmed": "#1E88E5",
  "In Transit": "#00ACC1",
  "Delayed- In Transit": "#D35400",
  "Delivery Appt Confirmed": "#3949AB",
  "Hot Shipment": "#D32F2F",
  "Delivered": "#2E7D32",
};

export const DEFAULT_EVENT_COLOR = "#999";
